// extracted by mini-css-extract-plugin
module.exports = {"className":"GuideStickyFooter--className","buttonLink":"GuideStickyFooter--buttonLink"};